import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { resetFormElement } from "src/design-system/styles/resets";
import SelectArrows from "./select-arrows.svg";

export const selectStyles = css`
  ${resetFormElement};
  padding-right: 16px;
  background: url(${SelectArrows}) no-repeat right center;
  background-size: 16px;
`;

const Select = styled.select(selectStyles);

export default Select;
